import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M512 0c-282.624 0-512 229.376-512 512s229.376 512 512 512c282.624 0 512-229.376 512-512s-229.376-512-512-512zM373.248 731.648l-183.808-183.808c-19.968-19.968-19.968-52.224 0-72.192s52.224-19.968 72.192 0l147.968 147.456 352.256-352.256c19.968-19.968 52.224-19.968 72.192 0s19.968 52.224 0 72.192l-388.608 388.608c-19.456 19.968-52.224 19.968-72.192 0z",
		fill: "rgb(43, 163, 239)"
	})
});
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
